import { StyleSheet } from 'react-native';

import Colors from '../../config/Colors';

export default StyleSheet.create({
    container: {
        flex: 1,
        padding: 20,
        backgroundColor: Colors.white,
        alignItems: 'center'
    },
    loginContainer: {
        alignItems: 'center',
        flexGrow: 1
    },
    formContainer: {
        flexGrow: 1,
        width: 340
    },
    logoContainer: {
        alignItems: 'center'
    },
    logo: {
        width: 88,
        height: 87,
        marginTop: 16,
        marginBottom: 32
    },
    input: {
        height: 60,
        backgroundColor: '#F5F5F5',
        marginBottom: 0,
        paddingVertical: 10,
        paddingHorizontal: 15,
        color: Colors.dark,
        fontSize: 16,
        borderRadius: 16,
        borderWidth: 1,
        borderColor: Colors.border,
    },
    inputUsername: {
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
        marginBottom: 0
    },
    inputPassword: {
        borderTopLeftRadius: 0,
        borderTopRightRadius: 0
    },
    error: {
        color: Colors.red,
        marginTop: 10
    }
});
